import * as yup from 'yup';
import { previousDamageSchema } from '@/features/Contract/Property/contractBaseSchema';

export const propertyPreviousDamageSharedWithElementarAndGlas =
  previousDamageSchema.concat(
    yup.object({
      vorschadenElementar: yup.boolean().default(false),
      elementarAnzahl: yup.number().when('vorschadenElementar', {
        is: (val: boolean) => val,
        then: yup.number().required().nullable().default(null),
        otherwise: yup.number().nullable().default(null),
      }),
      elementarEntschaedigung: yup.number().when('vorschadenElementar', {
        is: (val: boolean) => val,
        then: yup.number().required().nullable().default(null),
        otherwise: yup.number().nullable().default(null),
      }),
      vorschadenGlas: yup.boolean().default(false),
      glasAnzahl: yup.number().when('vorschadenGlas', {
        is: (val: boolean) => val,
        then: yup.number().required().nullable().default(null),
        otherwise: yup.number().nullable().default(null),
      }),
      glasEntschaedigung: yup.number().when('vorschadenGlas', {
        is: (val: boolean) => val,
        then: yup.number().required().nullable().default(null),
        otherwise: yup.number().nullable().default(null),
      }),
    }),
  );
